// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2HUXi","productName":"Table_productName__oIXtf"};